import { render, staticRenderFns } from "./Marsella.vue?vue&type=template&id=e9facc3a&scoped=true&"
import script from "./Marsella.vue?vue&type=script&lang=js&"
export * from "./Marsella.vue?vue&type=script&lang=js&"
import style0 from "./Marsella.vue?vue&type=style&index=0&id=e9facc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9facc3a",
  null
  
)

export default component.exports